import { PiAddressBookDuotone } from 'react-icons/pi';

import { FNodeChild, FNodeTypesEnum, FurnitureNode } from '@spazious/dollhouse-fsetup';
import { Translate } from '@spazious/dollhouse-i18n';
import { Flex, List, ListItem, Typography } from '@spazious/dollhouse-uikit';

const formatMetas = (meta: any) =>
  Object.entries(meta ?? {})
    .reduce((acc, [key, value]) => [...acc, `${key}: ${value}`], [] as string[])
    .join(', ');

export const DeleteNodesConfirmationForm: React.FC<{
  nodes: FNodeChild[];
}> = ({ nodes }) => {
  const { nodesToBeDeleted, nodesToBeHide } = nodes.reduce(
    (acc, node) => {
      if (node.type === FNodeTypesEnum.Furniture && node.visible) {
        return { ...acc, nodesToBeHide: [...acc.nodesToBeHide, node] };
      }

      return { ...acc, nodesToBeDeleted: [...acc.nodesToBeDeleted, node] };
    },
    {
      nodesToBeDeleted: [] as FNodeChild[],
      nodesToBeHide: [] as FurnitureNode[],
    }
  );
  return (
    <Flex column gap="calc(var(--spacing-gap) * 4)">
      <Typography variant="title">
        <Translate>This will remove the following from your diagram:</Translate>
      </Typography>
      {!!nodesToBeDeleted.length && (
        <Flex column gap="var(--spacing-gap)">
          <List>
            {nodesToBeDeleted.map((node) => (
              <ListItem
                key={node.uuid}
                avatar={<PiAddressBookDuotone />}
                subtitle={formatMetas(node.meta)}
                title={
                  node.type === FNodeTypesEnum.Furniture || node.type === FNodeTypesEnum.Decoration
                    ? node.name
                    : (FNodeTypesEnum as any)[node.type]
                }
              />
            ))}
          </List>
        </Flex>
      )}
      {!!nodesToBeHide.length && (
        <Flex gap="var(--spacing-gap)">
          <List>
            {nodesToBeHide.map((node) => (
              <ListItem
                key={node.uuid}
                avatar={<PiAddressBookDuotone />}
                subtitle={formatMetas(node.meta)}
                title={node.name}
              />
            ))}
          </List>
        </Flex>
      )}
    </Flex>
  );
};
